<!-- ////////////////////////////////////////////////////
    //     MODAL DE AGREGAR Y REPLICAR PROGRAMACION DE CLASE   //
///////////////////////////////////////////////////////////////////    -->
<!-- DESARROLLLO INICIADO EL MARTES 16-06-2021 ING WUILMER GARCIA -->
<!-- mensajes de confirmacion -->

<template>
    <div>


        <v-dialog v-model="compEstado" persistent scrollable max-width="80%">
            <v-card>
                <v-card-title class="modal_title py-5">
                    <v-row class="d-flex justify-space-between">
                        {{title}}
                        <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
 
                </v-card-title>

                <v-divider></v-divider>


                <v-card-text class="pt-4">

                <!-- Item01  PRINCIPAL LISTAR COMPETENCIAS -->
                <v-row >
                    <v-col cols="12" v-for="(item01,index01) in Datos" :key="index01">

                        <v-row v-if="index01==0" class="secondary black--text py-2 head-competencias">

                            <v-col cols="5" md="5" class="py-0 px-10">
                                <span class="font-weight-bold">COMPETENCIAS</span>
                            </v-col>

                            <v-col cols="5" md="7" class="py-0">
                                <span class="font-weight-bold">DESCRIPCIÓN </span>
                            </v-col>

                        </v-row>
                        


                        <v-row>
                            <v-col cols="12" md="12" class="py-0">
                                <span class="font-weight-bold">Nivel:{{item01.desc_nivel}} |  Grado:{{item01.desc_grado}}  | Área: {{item01.desc_area}}</span>
                            </v-col>
                        </v-row>
                        <!--  Item01  RENGLONES DE COMPETENCIAS -->
                        <v-row  v-for="(item02,index02) in item01.competencias" :key="index02">
                            <v-col cols="12" md="5" class="py-0 ">
                                <v-checkbox input-value="true" value disabled ></v-checkbox>
                            </v-col>

                            <v-col cols="12" md="5" class="py-0 d-flex justify-start align-center">

                                <div ><i class="fas fa-chevron-right fa-lg ico_competencia"></i> {{item02.desc_competencia}} </div>
                            </v-col>
                            
                
                            <!--  CAPACIADADES INSERT  v-model= "checkCapacidad" -->
                            <v-col cols="12" v-if="item02.capacidades">

                                <v-row> 

                                    <v-col cols="12" class="secondary black--text py-2 head-capacidades">
                                        <v-row>
                                            <v-col cols="9" offset="1">
                                                <span class="font-weight-bold">CAPACIDADES6</span>
                                            </v-col>

                                        
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>


                            <!-- Imten03 DETALLE DE CAPACIADADES -->


                            <v-col cols="12"  v-if="item02.capacidades">

                                <v-row v-for="(item03,index03) in item02.capacidades" :key="index03">

                                    <v-col cols="12" md="4" offset="1" class="py-0" >

                                        <v-checkbox input-value="true" value disabled ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" md="5" class="py-0 d-flex justify-start align-center">
                                        <div><i class="fas fa-caret-right fa-lg ico_capacidad "></i>{{item03.desc_capacidad}}</div>
                                    </v-col>

                                

                                    <!--
                                        /////////////////////////////////
                                        DESEMPEÑO O INIDICADORES
                                        /////////////////////////////////
                                    -->

                                    <v-col cols="12" v-if="item03.indicadores">

                                        <v-row>
                                            <v-col cols="12" class="secondary black--text py-2 head-desempenios" >
                                                <v-row>
                                                    <v-col cols="8" offset="2" class="px-10">
                                                        <span class="font-weight-bold">DESEMPEÑOS</span>
                                                    </v-col>                                                    
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                    </v-col>



                                    <!-- Imten03 DETALLE DE INDICADORES O DESEMPEÑO -->

                                    <v-col cols="12" v-if="item03.indicadores">
                                        <v-row v-for="(item04,index04) in item03.indicadores" :key="index04">

                                            <v-col cols="12" md="3"  class="py-0" offset="2">
                                                <v-checkbox input-value="true" value disabled ></v-checkbox>
                                            </v-col>
                                            
                                            <v-col cols="12" md="5"  class="py-0 d-flex justify-start align-center">
                                                <div><i class="fas fa-angle-double-right fa-lg ico_indicador"></i>{{item04.desc_indicador}}</div>
                                            </v-col>
                                        
                                        </v-row>
                                    </v-col>


                                </v-row>



                            </v-col>


                
                            <!-- FIN DE CAPACIDADES -->
                        </v-row>
                    </v-col>

                </v-row>

                <span v-if="test">
                    PARAMETROS <code>{{compParametro}}</code> <br/>
                    
                    Datos <code>{{Datos}}</code> <br/>
                    <!--
                        competenciasCheck <code>{{competenciasCheck}}</code> <br/>
                        capacidadesCheck <code>{{capacidadesCheck}}</code> <br/>
                        indicadoresCheck <code>{{indicadoresCheck}}</code> <br/>
                    -->
                
                </span>             

                </v-card-text>

            </v-card>

        </v-dialog>


        <!--   END  COMPETENCIAS CAPACIDADES Y DESEMPEÑO-->


        
    </div>
</template>




<script>
    // import axios,  { API_URL } from '@/helpers/axios'
    // import '@/assets/css/competencia_cap_ind.css';
    import '@/assets/css/competencia.css';    
    import axios from '@/helpers/axios'
    import {mapMutations, mapGetters } from 'vuex' //mapActions


    export default {
        name: "progDocCompetencia",
        props:['compEstado', 'compParametro'],


        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            datoLogin: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////
            
            Datos     : [],              
            evento    : null,
            test      : false,
            title     : "COMPETENCIAS PROGRAMADAS",
           
            competenciasCheck : [],
            capacidadesCheck  : [],
            indicadoresCheck  : []


        }),

        computed: {
            ...mapGetters('login', [ 'componenteEvento']),
        },


       
        watch: {
            // cada vez que la pregunta cambie desde el componente padre, esta función será ejecutada
            compEstado() {

                if(this.compEstado){
                    this.loadMain()
                }else{
                    this.limpiarForm()
                }
            }
        },


        mounted() {
            this.loadMain()
        },


        created(){    },


        methods: {
        
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////

            //  ------- MOSTRAR TODOS LOS REGISTROS    --------
            async loadMain(){

                try{
                    this.limpiarForm()                  
                    await this.getQuery()       
                    
 
             
                }
                catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },

  
            async limpiarForm(){  
                this.Datos = []   
                
                this.competenciasCheck = [true]
                this.capacidadesCheck  = [true]
                this.indicadoresCheck  = [true]
            },

 

            async getQuery(){   
        
                try{                 
                    // let filtro = {"id_ano_lectivo": this.filtro.id_ano_lectivo, "id_curriculo": this.filtro.id_curriculo, 
                    // "id_colegio": this.filtro.id_colegio, "id_nivel": null, "id_grado": null, "id_area": null}
                    
                    // CORRECTO
                    // let resp = await axios.post(`/administrativo/competencia/cs/all/`,this.filtro )

                    let resp = await axios.get(`/academico/progDocenteCompetencia/compCapInd/colegio/${this.compParametro.id_colegio}/prog_doc/${this.compParametro.id}` )
                    this.Datos =  resp.data

                    if(!this.Datos){
                        this.setEnviarMens({tipo:"E", mensaje: `No existe información asociada para  `, tiempo:10000})
                    }
                 

                }catch(error)
                {
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }

            },



            cancelar() {
                console.log("confirm FALSE")
                this.clear_confirm();
                this.$emit('close')
            },

            clear_confirm() {
                this.confirm.id = 0;
                this.confirm.title = "";
                this.confirm.active = false;
            },



        
        }
    }
</script>

<style scoped>

.ico_competencia{
    color: #e53935 !important;
}

.ico_capacidad{
   color: #388e3c !important;
}

.ico_indicador{
   color:#01579b !important;
}

.head-competencias{ 
    background: #0277BD !important; 
    color: white !important;
}

.head-capacidades{
    background: #59B9F2 !important;
    color: white !important;
}
.head-desempenios{
    background: #D0EAF9 !important;
    color: white !important;
}
</style>       
